export function shallowEqualArray(a, b) {
    if (Object.is(a, b)) {
        return true;
    }
    if (a == null || b == null || a.length !== b.length) {
        return false;
    }
    for(let i = 0; i < a.length; i++){
        if (!Object.is(a[i], b[i])) {
            return false;
        }
    }
    return true;
}

//# sourceMappingURL=shallowEqualArray.js.map